import { Icons } from '@/components/Shares/Icons';
import { useLingui } from '@lingui/react';
import { ActionIcon, Box, CopyButton, Group, Paper, Stack, Text, Tooltip, rem } from '@mantine/core';
export type TransactionDetailProps = {
  status: string;
  txID: string;
  orderID: string;
  time: string;
};
export const TransactionDetail: React.FC<TransactionDetailProps> = ({
  status,
  txID,
  orderID,
  time
}) => {
  const {
    i18n
  } = useLingui();
  return <Paper w="100%" radius={5} p={{
    base: 10,
    sm: 20
  }} bg="dark.12">
      <Stack gap="xs">
        <Group justify="space-between">
          <Text fz={{
          base: 12,
          sm: 13
        }} fw={700} c="var(--text-dark)" tt="uppercase">
            {i18n._('Status')}
          </Text>
          <Text fz={12} fw={700} c="var(--text-green)" tt="uppercase">
            {status}
          </Text>
        </Group>

        <Group justify="space-between">
          <Text fz={{
          base: 12,
          sm: 13
        }} fw={700} c="var(--text-dark)">
            {i18n._('TXID')}
          </Text>

          <Group wrap="nowrap" gap={4} justify="space-between" px={{
          base: 12,
          sm: 16
        }} py={8} bg="var(--input-variant-color)" style={{
          borderRadius: rem(5)
        }}>
            <Box w={{
            base: 187,
            sm: 351,
            md: 280,
            lg: 312
          }}>
              <Text fz={{
              base: 12,
              sm: 13
            }} fw={500} c="var(--text-white)" truncate="end">
                {txID}
              </Text>
            </Box>

            <CopyButton value={txID} timeout={2000}>
              {({
              copied,
              copy
            }) => <Tooltip label={copied ? 'Copied' : 'Copy'} withArrow position="right">
                  <ActionIcon color={copied ? 'teal' : 'gray'} variant="subtle" onClick={copy}>
                    {copied ? <Icons className="icon-pr-line-checked" fontSize={24} /> : <Icons className="icon-pr-line-copy" fontSize={24} />}
                  </ActionIcon>
                </Tooltip>}
            </CopyButton>
          </Group>
        </Group>

        <Group justify="space-between">
          <Text fz={{
          base: 12,
          sm: 13
        }} fw={700} c="var(--text-dark)" tt="uppercase">
            {i18n._('Order ID')}
          </Text>

          <Group wrap="nowrap" gap={4} justify="space-between" px={{
          base: 12,
          sm: 16
        }} py={8} bg="var(--input-variant-color)" style={{
          borderRadius: rem(5)
        }}>
            <Box w={{
            base: 187,
            sm: 351,
            md: 280,
            lg: 312
          }}>
              <Text fz={{
              base: 12,
              sm: 13
            }} fw={500} c="var(--text-white)" truncate="end">
                {orderID}
              </Text>
            </Box>

            <CopyButton value={orderID} timeout={2000}>
              {({
              copied,
              copy
            }) => <Tooltip label={copied ? 'Copied' : 'Copy'} withArrow position="right">
                  <ActionIcon color={copied ? 'teal' : 'gray'} variant="subtle" onClick={copy}>
                    {copied ? <Icons className="icon-pr-line-checked" fontSize={24} /> : <Icons className="icon-pr-line-copy" fontSize={24} />}
                  </ActionIcon>
                </Tooltip>}
            </CopyButton>
          </Group>
        </Group>

        <Group justify="space-between">
          <Text fz={{
          base: 12,
          sm: 13
        }} fw={700} c="var(--text-dark)" tt="uppercase">
            {i18n._('Time')}
          </Text>
          <Text fz={12} fw={700} c="var(--text-dark)" tt="uppercase">
            {time}
          </Text>
        </Group>
      </Stack>
    </Paper>;
};